import React from 'react';
import { useHandleSignInCallback } from '@logto/react';
import { useNavigate } from 'react-router-dom';
import { RETURN_URL_KEY } from '@/logto';

// Landing spot for Logto's redirect after sign-in. The SDK reads the auth code
// off the query string, exchanges it for tokens, and then we move on.
const AuthCallback = () => {
  const navigate = useNavigate();

  const { error } = useHandleSignInCallback(() => {
    // Send the user back where they were headed before being bounced to login.
    const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);
    sessionStorage.removeItem(RETURN_URL_KEY);

    // Only accept same-site relative paths, so a tampered value can't turn the
    // callback into an open redirect.
    const target =
      returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')
        ? returnUrl
        : '/dashboard';

    navigate(target, { replace: true });
  });

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white border border-gray-200 rounded-lg p-8 text-center">
          <h1 className="text-xl font-semibold text-gray-900 mb-2">Sign-in failed</h1>
          <p className="text-sm text-gray-600 mb-6">{error.message}</p>
          <button
            onClick={() => navigate('/login', { replace: true })}
            className="px-4 py-2 rounded-md bg-gray-900 text-white text-sm hover:bg-gray-800"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-gray-300 border-t-gray-900 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-gray-600">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
